var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1947_64977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.625 9.42913L8.99998 15.0001L3.37498 9.42913C3.00396 9.06809 2.71171 8.63414 2.51664 8.15461C2.32157 7.67508 2.2279 7.16035 2.24153 6.64283C2.25517 6.12532 2.3758 5.61623 2.59585 5.14764C2.8159 4.67904 3.13058 4.26107 3.5201 3.92007C3.90961 3.57906 4.36551 3.3224 4.85909 3.16624C5.35267 3.01009 5.87324 2.95782 6.38801 3.01273C6.90278 3.06765 7.40061 3.22855 7.85014 3.48531C8.29967 3.74207 8.69117 4.08913 8.99998 4.50463C9.31013 4.09215 9.70208 3.74812 10.1513 3.49409C10.6005 3.24005 11.0974 3.08147 11.6107 3.02827C12.124 2.97508 12.6428 3.02841 13.1346 3.18493C13.6263 3.34145 14.0805 3.59779 14.4686 3.93791C14.8568 4.27802 15.1706 4.6946 15.3903 5.16155C15.61 5.62851 15.731 6.1358 15.7457 6.65166C15.7604 7.16753 15.6684 7.68088 15.4756 8.15957C15.2827 8.63826 14.9932 9.072 14.625 9.43363",
    stroke: "#616E85",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99989 4.5L6.53014 6.96975C6.38953 7.1104 6.31055 7.30113 6.31055 7.5C6.31055 7.69887 6.38953 7.8896 6.53014 8.03025L6.93739 8.4375C7.45489 8.955 8.29489 8.955 8.81239 8.4375L9.56239 7.6875C10.0099 7.23995 10.617 6.98852 11.2499 6.98852C11.8828 6.98852 12.4898 7.23995 12.9374 7.6875L14.6249 9.375",
    stroke: "#616E85",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 11.625L10.875 13.125",
    stroke: "#616E85",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9.75L12.75 11.25",
    stroke: "#616E85",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1947_64977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerLocation);
export default __webpack_public_path__ + "static/media/PartnerLocation.b4cab4dbf276a5112921a0b689ec620a.svg";
export { ForwardRef as ReactComponent };